import * as LucideIcons from 'lucide-react';
import type { LucideProps } from 'lucide-react';
import type { ComponentType } from 'react';

// Icons are `forwardRef` objects, not functions, so no runtime predicate
// distinguishes one from the module's other exports. The lookup is a plain
// index, as it was at each call site before; the assertion is confined here.
const ICONS = LucideIcons as unknown as Record<string, ComponentType<LucideProps> | undefined>;

export function toPascalCase(name: string): string {
  return name.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join('');
}

/** Resolves a kebab-case icon name to its Lucide component, or undefined. */
export function lucideIcon(name: string): ComponentType<LucideProps> | undefined {
  return ICONS[toPascalCase(name)];
}
